// extracted by mini-css-extract-plugin
export default {"header":"Title_header__jhcGa","appName":"Title_appName__RBJBL","actionIconsAdd":"Title_actionIconsAdd__1XOK9"};